import React, { useState, useEffect } from 'react';
import { useAuth, API } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [campanhas, setCampanhas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/campanhas`).then(res => setCampanhas(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const porStatus = (s) => campanhas.filter(c => c.status === s);

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;

  return (
    <div>
      <h4 className="fw-bold mb-4">Dashboard</h4>
      <p style={{ color: '#888', fontSize: '0.85rem' }}>Bem-vindo, {user?.nome}</p>

      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <div className="card card-stat p-3">
            <div style={{ fontSize: '0.78rem', color: '#888' }}>Campanhas Ativas</div>
            <div style={{ fontSize: '1.6rem', fontWeight: 700, color: '#2e7d5b' }}>{porStatus('ativa').length}</div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-stat p-3">
            <div style={{ fontSize: '0.78rem', color: '#888' }}>Em Preenchimento</div>
            <div style={{ fontSize: '1.6rem', fontWeight: 700, color: '#856404' }}>{porStatus('preenchimento').length}</div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-stat p-3">
            <div style={{ fontSize: '0.78rem', color: '#888' }}>Aguardando Aprovação</div>
            <div style={{ fontSize: '1.6rem', fontWeight: 700, color: '#004085' }}>{porStatus('aprovacao').length}</div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card card-stat p-3">
            <div style={{ fontSize: '0.78rem', color: '#888' }}>Total Campanhas</div>
            <div style={{ fontSize: '1.6rem', fontWeight: 700 }}>{campanhas.length}</div>
          </div>
        </div>
      </div>

      {campanhas.length > 0 && (
        <div className="card p-3">
          <h6 className="fw-bold mb-3">Campanhas Recentes</h6>
          <div className="tabela-container">
            <table className="table table-mkt table-hover mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Período</th>
                  <th>Produtos</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {campanhas.slice(0, 10).map(c => (
                  <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/campanhas/${c.id}/produtos`)}>
                    <td className="fw-semibold">{c.nome}</td>
                    <td style={{ fontSize: '0.83rem' }}>
                      {c.data_inicio ? new Date(c.data_inicio).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '—'}
                      {' → '}
                      {c.data_fim ? new Date(c.data_fim).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '—'}
                    </td>
                    <td>{c.qtd_produtos || 0} ({c.qtd_aprovados || 0} aprovados)</td>
                    <td><span className={`badge-${c.status}`}>{c.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
